var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOkc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9199 -8250)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-9199 8250)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14124.057 6478.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4946.074,1793.653a1.579,1.579,0,0,0,1.293-.722,4.191,4.191,0,0,1,7.6,1.064,4.186,4.186,0,0,1-1.792,4.719,4.276,4.276,0,0,1-4.827-.251,4.233,4.233,0,0,1-1.593-2.719c-.019-.109-.035-.218-.062-.39-.383.094-.749.175-1.108.274-1.986.542-3.969,1.092-5.955,1.632-2.126.578-4.255,1.147-6.382,1.722-.356.1-.708.207-1.065.3a.884.884,0,1,1-.46-1.7c1.966-.533,3.934-1.057,5.9-1.59,2.085-.566,4.166-1.143,6.25-1.7a.457.457,0,0,0,.4-.532q-.021-5.03-.006-10.061a3.842,3.842,0,0,1,.511-2.095,3.243,3.243,0,0,1,2.833-1.593c2.164-.031,4.33-.011,6.495-.007.728,0,1.151.5.976,1.144a.75.75,0,0,1-.657.59,4.79,4.79,0,0,1-.668.056c-2.03,0-4.061.033-6.091-.012a1.633,1.633,0,0,0-1.624,1.6c.015,3.32.006,6.64.007,9.961C4946.051,1793.435,4946.064,1793.523,4946.074,1793.653Zm4.842,3.918a2.432,2.432,0,0,0,2.449-2.423,2.445,2.445,0,1,0-2.449,2.423Z",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4945.9,1860.974a1,1,0,0,1-1.071-.8c-.366-1.281-.709-2.569-1.061-3.854-.181-.659-.356-1.319-.539-1.977a1.118,1.118,0,0,1,.818-1.51c.483-.144.971-.272,1.452-.422.215-.067.3,0,.353.21.2.78.424,1.555.631,2.334.181.682.451.844,1.121.656.292-.082.584-.161.869-.259a.614.614,0,0,0,.456-.836c-.213-.835-.433-1.67-.674-2.5-.074-.252-.02-.331.228-.389.468-.109.925-.268,1.391-.386a1.172,1.172,0,0,1,1.5.878q.767,2.852,1.524,5.7a1.192,1.192,0,0,1-.893,1.578q-2.8.754-5.605,1.5A3.789,3.789,0,0,1,4945.9,1860.974Z",
    transform: "translate(-11.373 -66.41)",
    fill: "#71aff8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOkc);
export default __webpack_public_path__ + "static/media/icon-okc.0cc16ae7.svg";
export { ForwardRef as ReactComponent };